var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import { FilterVerticalIcon } from 'hugeicons-react';
import useTranslate from '../../localization/helpers';
var FilterButton = function (_a) {
    var onClick = _a.onClick, _b = _a.filterValue, filterValue = _b === void 0 ? '' : _b, icon = _a.icon, buttonProps = __rest(_a, ["onClick", "filterValue", "icon"]);
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isScreen329350 = useMediaQuery('(min-width:328px) and (max-width:351px)');
    if (icon) {
        return (_jsx(IconButton, __assign({ size: 'small', color: 'primary', onClick: onClick }, buttonProps, { children: _jsx(FilterVerticalIcon, {}) })));
    }
    return (_jsxs(Button, __assign({ size: isXs ? 'small' : 'medium', variant: 'soft', color: 'primary', onClick: onClick, startIcon: _jsx(FilterVerticalIcon, { size: isScreen329350 ? 14 : isXs ? 17 : undefined }) }, buttonProps, { children: [translate('common.filters'), filterValue && (_jsx(Box, { sx: {
                    backgroundColor: theme.palette.grey[300],
                    color: theme.palette.grey[800],
                    borderRadius: '50%',
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    marginLeft: 1,
                    fontWeight: 'bold'
                }, children: filterValue }))] })));
};
export default FilterButton;
